import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View``;

export const GridLogoWrapper = styled.View<{width: number; height: number}>`
  width: ${({width}) => width}px;
  height: ${({height}) => height}px;
  border-radius: ${RFValue(14)}px;
  background-color: ${({theme}) => theme.colors.shape};
  align-self: center;

`;

export const logoWrapperShadow = {
  shadowColor: '#000',
  shadowOffset: {width: 0, height: 1},
  shadowOpacity: 0.06,
  shadowRadius: 10,
  elevation: 1,
};

export const GridLogo = styled(FastImage)`
  border-radius: ${RFValue(14)}px;
  
  border: 1px solid ${({theme}) => theme.colors.border2};
`;

export const GridName = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(8.5)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  margin-top: ${RFValue(5)}px;
  text-align: center;
  text-transform: capitalize;
`;

export const GridDiscount = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  text-align: center;
`;
